import LoadingState from '../../../../../../values/loading-state-enum'
import {DEFAULT_FLEET_SCORE_OVER_TIME_FILTERS} from './fleet-score-over-time-filter'
import {FleetScoreOverTimeState} from './fleet-score-over-time-state'

export const DEFAULT_FLEET_SCORE_OVER_TIME_STATE: FleetScoreOverTimeState = {
    loadingFilterState: LoadingState.NotPopulated,
    fleetScoreOverTimeFilter: DEFAULT_FLEET_SCORE_OVER_TIME_FILTERS,
    showFilter: false,
}
